import React from "react";

/**
 * AdBanner — toned-down "Partner with us" affordance shown in the
 * global footer slot. The earlier "AD SPACE • COMING SOON" copy made
 * the whole app look unfinished on production — until real
 * ads/partnerships ship, we render a single tasteful one-liner that
 * points to the contact page → `advertise` tab.
 *
 * Wired into the global layout in App.js so it appears under the page
 * body and above the footer. Returning `null` from the component will
 * hide the slot entirely — useful for routes that need the chrome
 * minimal (e.g. checkout flows).
 */
export function AdBanner() {
  return (
    <div className="page-z w-full px-4 sm:px-6 lg:px-10 mt-12">
      <div className="max-w-screen-xl mx-auto flex justify-center">
        <a
          href="/contact?topic=advertise"
          data-testid="partner-cta"
          className="text-[11px] tracking-[2px] text-white/40 hover:text-[#14b8a6] transition-colors inline-flex items-center gap-2"
        >
          <i className="fas fa-handshake-angle" />
          PARTNER WITH LEAGUE HUB
        </a>
      </div>
    </div>
  );
}

export default AdBanner;
